{
  "it": {
    "notification": {
      "actions": {
        "delete": "Elimina notifica",
        "deleteAll": "Elimina tutto",
        "markAllAsRead": "Segna tutte come lette",
        "mark_as_read": "Segna come letta",
        "mark_as_unread": "Segna come non letta"
      },
      "customers": {
        "announcement": {
          "create": "ha creato una novità. | ha creato {group_notification_count} novità. |_| hanno creato {group_notification_count} novità."
        },
        "decision": {
          "message": {
            "create": "ha inviato un nuovo messaggio nella conversazione <i>'{group_name}'</i>. | ha inviato {group_notification_count} nuovi messaggi nella conversazione <i>'{group_name}'</i>. |_| hanno inviato {group_notification_count} nuovi messaggi nella conversazione <i>'{group_name}'</i>."
          },
          "published": {
            "customer": "ha aggiunto la decisione <i>'{notifiable_name}'</i>."
          },
          "relaunched": "ha reso di nuovo disponibile la decisione <i>'{notifiable_name}'</i>."
        },
        "decision_document": {
          "create": "ha caricato il documento <i>'{notifiable_name}'</i> nella decisione <i>'{group_name}'</i>. | ha caricato {group_notification_count} documenti nella decisione <i>'{group_name}'</i>. |_| hanno caricato {group_notification_count} documenti nella decisione <i>'{group_name}'</i>."
        },
        "decision_proposal": {
          "approved": "ha approvato la proposta <i>'{notifiable_name}'</i> nella decisione <i>'{group_name}'</i>. | ha approvato {group_notification_count} proposte nella decisione <i>'{group_name}'</i>. | ha approvato {group_notification_count} proposte nella decisione <i>'{group_name}'</i>.",
          "create": "ha creato la proposta <i>'{notifiable_name}'</i> nella decisione <i>'{group_name}'</i>. | ha creato {group_notification_count} proposte nella decisione <i>'{group_name}'</i>. | ha creato {group_notification_count} proposte nella decisione <i>'{group_name}'</i>.",
          "edit_approved": "ha modificato la proposta approvata <i>'{notifiable_name}'</i> nella decisione <i>'{group_name}'</i>. | ha modificato {group_notification_count} proposte approvate nella decisione <i>'{group_name}'</i>. | ha modificato {group_notification_count} proposte approvate nella decisione <i>'{group_name}'</i>.",
          "relaunched": "ha reso di nuovo disponibile la proposta <i>'{notifiable_name}'</i> per cui aveva richiesto modifiche | ha reso di nuovo disponibili {group_notification_count} proposte nella decisione <i>'{group_name}'</i> per cui aveva richiesto modifiche | ha reso di nuovo disponibili {group_notification_count} proposte nella decisione <i>'{group_name}'</i> per cui aveva richiesto modifiche"
        },
        "document": {
          "create": "ha caricato il documento <i>'{notifiable_name}'</i>. | ha caricato {group_notification_count} documenti. |_| hanno caricato {group_notification_count} documenti.",
          "installment": {
            "create": "ha aggiunto la fattura <i>'{notifiable_name}'</i> a una rata. | ha aggiunto {group_notification_count} fatture a una rata. |_| hanno aggiunto {group_notification_count} fatture a una rata."
          },
          "invoice": {
            "create": "ha caricato la fattura <i>'{notifiable_name}'</i>. | ha caricato {group_notification_count} fatture. |_| hanno caricato {group_notification_count} fatture."
          },
          "proposal": {
            "create": "ha aggiunto il documento <i>'{notifiable_name}'</i> alla proposta <i>'{group_name}'</i>. | ha aggiunto {group_notification_count} documenti alla proposta <i>'{group_name}'</i>. |_| hanno aggiunto {group_notification_count} documenti alla proposta <i>'{group_name}'</i>."
          }
        },
        "export": {
          "create": "I Suoi dati esportati sono pronti per essere scaricati."
        },
        "installment": {
          "published": "ha reso disponibile la rata <i>'{notifiable_name}'</i>. | ha reso disponibili {group_notification_count} rate. | ha reso disponibili {group_notification_count} rate.",
          "status": {
            "changed": "ha cambiato lo stato della rata <i>'{notifiable_name}'</i> in <i>'{status}'</i>. | ha cambiato lo stato di {group_notification_count} rate. | ha cambiato lo stato di {group_notification_count} rate."
          }
        },
        "issue": {
          "approval": {
            "create": "ha richiesto l'approvazione per la segnalazione <i>'{notifiable_name}'</i> | ha richiesto l'approvazione per {group_notification_count} segnalazioni. | ha richiesto l'approvazione per {group_notification_count} segnalazioni."
          },
          "create": "ha creato la segnalazione <i>'{notifiable_name}'</i> | ha creato {group_notification_count} segnalazioni | ha creato {group_notification_count} segnalazioni",
          "message": {
            "create": "ha inviato un nuovo messaggio nella conversazione <i>'{group_name}'</i>. | ha inviato {group_notification_count} nuovi messaggi nella conversazione <i>'{group_name}'</i>. |_| hanno inviato {group_notification_count} nuovi messaggi nella conversazione <i>'{group_name}'</i>."
          },
          "status": {
            "update": "ha aggiornato lo stato di <i>'{notifiable_name}'</i> a <i>'{status}'</i> | ha aggiornato lo stato di {group_notification_count} segnalazioni. | ha aggiornato lo stato di {group_notification_count} segnalazioni."
          }
        },
        "question": {
          "create": "ha creato la domanda <i>'{notifiable_name}'</i> nelle FAQ <i>'{group_name}'</i>. | ha creato {group_notification_count} domande nelle FAQ <i>'{group_name}'</i>. |_| hanno creato {group_notification_count} domande nelle FAQ <i>'{group_name}'</i>."
        },
        "reminder": {
          "decision": {
            "due": "Non dimentichi di prendere una decisione per <i>'{notifiable_name}'</i>."
          },
          "installment": {
            "due": "Non dimentichi di effettuare un pagamento per <i>'{notifiable_name}'</i>."
          }
        },
        "survey": {
          "published": "vorrebbe il Suo feedback su <i>'{group_name}'</i>."
        },
        "task_assignment": {
          "confirmation": {
            "requested": "Le chiede di confermare <i>'{notifiable_name}'</i>."
          },
          "upload": {
            "requested": "Le chiede di caricare un documento per <i>'{notifiable_name}'</i>."
          }
        },
        "ticket": {
          "create": "ha avviato la conversazione <i>'{notifiable_name}'</i>.",
          "message": {
            "create": "ha inviato un nuovo messaggio nella conversazione <i>'{group_name}'</i>. | ha inviato {group_notification_count} nuovi messaggi nella conversazione <i>'{group_name}'</i>. |_| hanno inviato {group_notification_count} nuovi messaggi nella conversazione <i>'{group_name}'</i>.",
            "move": "ha spostato il Suo messaggio nella conversazione <i>'{group_name}'</i>"
          }
        },
        "ticket_document": {
          "create": "ha caricato il documento <i>'{notifiable_name}'</i> nella conversazione <i>'{group_name}'</i>. | ha caricato {group_notification_count} documenti nella conversazione <i>'{group_name}'</i>. |_| hanno caricato {group_notification_count} documenti nella conversazione <i>'{group_name}'</i>."
        }
      },
      "employees": {
        "announcement": {
          "create": "ha creato una novità. | ha creato {group_notification_count} novità in <i>'{group_name}'</i>. |_| hanno creato {group_notification_count} novità in <i>'{group_name}'</i>."
        },
        "conversation_agent": {
          "activated": "ha attivato l'assistente IA. Può disattivarlo nelle impostazioni."
        },
        "decision": {
          "mention": {
            "create": "L'ha menzionata nella conversazione <i>'{group_name}'</i>. | L'ha menzionata in {group_notification_count} messaggi nella conversazione <i>'{group_name}'</i>. |_| L'hanno menzionata in {group_notification_count} messaggi nella conversazione <i>'{group_name}'</i>."
          },
          "message": {
            "create": "ha inviato un nuovo messaggio nella conversazione <i>'{group_name}'</i>. | ha inviato {group_notification_count} nuovi messaggi nella conversazione <i>'{group_name}'</i>. |_| hanno inviato {group_notification_count} nuovi messaggi nella conversazione <i>'{group_name}'</i>."
          },
          "not_interested": "non è interessato alla decisione <i>'{notifiable_name}'</i>.",
          "responsible": {
            "update": "L'ha reso il nuovo responsabile della decisione <i>'{notifiable_name}'</i>"
          }
        },
        "decision_document": {
          "create": "ha caricato il documento <i>'{notifiable_name}'</i> nella decisione <i>'{group_name}'</i>. | ha caricato {group_notification_count} documenti nella decisione <i>'{group_name}'</i>. |_| hanno caricato {group_notification_count} documenti nella decisione <i>'{group_name}'</i>."
        },
        "decision_proposal": {
          "approved": "ha approvato la proposta <i>'{notifiable_name}'</i> nella decisione <i>'{group_name}'</i>. | ha approvato {group_notification_count} proposte nella decisione <i>'{group_name}'</i>. |_| hanno approvato {group_notification_count} proposte nella decisione <i>'{group_name}'</i>.",
          "create": "ha creato la proposta <i>'{notifiable_name}'</i> nella decisione <i>'{group_name}'</i>. | ha creato {group_notification_count} proposte nella decisione <i>'{group_name}'</i>. |_| hanno creato {group_notification_count} proposte nella decisione <i>'{group_name}'</i>.",
          "requested_changes": "chiede modifiche per la proposta <i>'{notifiable_name}'</i> nella decisione <i>'{group_name}'</i>. | chiede modifiche per {group_notification_count} proposte nella decisione <i>'{group_name}'</i>. |_| chiedono modifiche per {group_notification_count} proposte nella decisione <i>'{group_name}'</i>."
        },
        "document": {
          "create": "ha caricato il documento <i>'{notifiable_name}'</i> nella cartella <i>'{group_name}'</i>. | ha caricato {group_notification_count} documenti nella cartella <i>'{group_name}'</i>. |_| hanno caricato {group_notification_count} documenti nella cartella <i>'{group_name}'</i>.",
          "employee_create": "ha caricato il documento <i>'{notifiable_name}'</i> nella cartella <i>'{group_name}'</i>. | ha caricato {group_notification_count} documenti nella cartella <i>'{group_name}'</i>. |_| hanno caricato {group_notification_count} documenti nella cartella <i>'{group_name}'</i>.",
          "proposal": {
            "create": "ha aggiunto il documento <i>'{notifiable_name}'</i> alla proposta <i>'{group_name}'</i>. | ha aggiunto {group_notification_count} documenti alla proposta <i>'{group_name}'</i>. |_| hanno aggiunto {group_notification_count} documenti alla proposta <i>'{group_name}'</i>."
          }
        },
        "email_conversation": {
          "client": {
            "create": "ha ricevuto un'email in arrivo <i>'{notifiable_name}'</i>. | ha ricevuto {group_notification_count} email in arrivo. |_| hanno ricevuto {group_notification_count} email in arrivo."
          },
          "project": {
            "create": "ha ricevuto un'email in arrivo <i>'{notifiable_name}'</i>. | ha ricevuto {group_notification_count} email in arrivo. |_| hanno ricevuto {group_notification_count} email in arrivo."
          }
        },
        "export": {
          "create": "I Suoi dati esportati sono pronti per essere scaricati."
        },
        "issue": {
          "approved": "ha approvato la segnalazione <i>'{notifiable_name}'</i> per l'unità <i>'{level_name}'</i>. | ha approvato {group_notification_count} segnalazioni'</i>. |_| hanno approvato {group_notification_count} segnalazioni.",
          "create": "ha creato una nuova segnalazione per l'unità <i>{level_name}</i> | ha creato {group_notification_count} nuove segnalazioni per <i>{level_name}</i> |_| hanno creato {group_notification_count} nuove segnalazioni per <i>{level_name}</i>",
          "mention": {
            "create": "L'ha menzionata nella conversazione <i>'{group_name}'</i>. | L'ha menzionata in {group_notification_count} messaggi nella conversazione <i>'{group_name}'</i>. |_| L'hanno menzionata in {group_notification_count} messaggi nella conversazione <i>'{group_name}'</i>."
          },
          "message": {
            "create": "ha inviato un nuovo messaggio nella conversazione <i>'{group_name}'</i>. | ha inviato {group_notification_count} nuovi messaggi nella conversazione <i>'{group_name}'</i>. |_| hanno inviato {group_notification_count} nuovi messaggi nella conversazione <i>'{group_name}'</i>."
          },
          "rejected": "ha rifiutato la segnalazione <i>'{notifiable_name}'</i> per l'unità <i>'{level_name}'</i>. | ha rifiutato {group_notification_count} segnalazioni'</i>. |_| hanno rifiutato {group_notification_count} segnalazioni."
        },
        "issue_list": {
          "responsible": {
            "update": "L'ha reso il nuovo responsabile dell'elenco segnalazioni <i>'{notifiable_name}'</i>."
          }
        },
        "question": {
          "create": "ha creato la domanda <i>'{notifiable_name}'</i> nelle FAQ <i>'{group_name}'</i>. | ha creato {group_notification_count} domande nelle FAQ <i>'{group_name}'</i>. |_| hanno creato {group_notification_count} domande nelle FAQ <i>'{group_name}'</i>."
        },
        "survey_answer": {
          "create": "ha risposto a <i>'{group_name}'</i>."
        },
        "task_assignment": {
          "completed": "ha completato <i>'{notifiable_name}'</i>.",
          "confirmation": {
            "requested": "Le chiede di confermare <i>'{notifiable_name}'</i>."
          },
          "upload": {
            "requested": "Le chiede di caricare un documento per <i>'{notifiable_name}'</i>."
          }
        },
        "ticket": {
          "create": "ha avviato la conversazione <i>'{notifiable_name}'</i>.",
          "mention": {
            "create": "L'ha menzionata nella conversazione <i>'{group_name}'</i>. | L'ha menzionata in {group_notification_count} messaggi nella conversazione <i>'{group_name}'</i>. |_| L'hanno menzionata in {group_notification_count} messaggi nella conversazione <i>'{group_name}'</i>."
          },
          "message": {
            "create": "ha inviato un nuovo messaggio nella conversazione <i>'{group_name}'</i>. | ha inviato {group_notification_count} nuovi messaggi nella conversazione <i>'{group_name}'</i>. |_| hanno inviato {group_notification_count} nuovi messaggi nella conversazione <i>'{group_name}'</i>."
          },
          "responsible": {
            "bulk_update": "Le ha trasferito da <i>{responsible_old_name}</i> la responsabilità delle conversazioni nel progetto <i>'{project_name}'</i>.",
            "update": "Le ha assegnato la conversazione <i>'{notifiable_name}'</i>."
          }
        },
        "ticket_document": {
          "create": "ha caricato il documento <i>'{notifiable_name}'</i> nella conversazione <i>'{group_name}'</i>. | ha caricato {group_notification_count} documenti nella conversazione <i>'{group_name}'</i>. |_| hanno caricato {group_notification_count} documenti nella conversazione <i>'{group_name}'</i>."
        },
        "todo": {
          "assign": "Le ha assegnato l'attività <i>'{notifiable_name}'</i> nell'elenco <i>'{group_name}'</i>. | Le ha assegnato {group_notification_count} attività nell'elenco <i>'{group_name}'</i>. | Le ha assegnato l'attività <i>'{notifiable_name}'</i> nell'elenco <i>'{group_name}'</i>. | Le ha assegnato {group_notification_count} attività nell'elenco <i>'{group_name}'</i>."
        }
      },
      "labels": {
        "all": "Tutti i progetti",
        "allDecisions": "Tutte le decisioni",
        "allStatuses": "Tutti",
        "compactView": "Vista compatta",
        "expandedView": "Vista estesa",
        "filter": "Filtro",
        "hideDecisionFilter": "Nascondi filtro decisioni",
        "hideExtraFilters": "Nascondi filtri aggiuntivi",
        "noNewNotification": "È tutto aggiornato.",
        "noResults": "Nessun risultato. Provi con altri termini.",
        "none": "Al momento non ha notifiche.",
        "notification_level_name_asc": "Unità A->Z",
        "notification_level_name_desc": "Unità Z->A",
        "pinSidebar": "Blocca barra laterale",
        "showDecisionFilter": "Mostra filtro decisioni",
        "showExtraFilters": "Mostra filtri aggiuntivi",
        "sort": "Ordina per",
        "status": "Stato",
        "unpinSidebar": "Sblocca barra laterale",
        "unreadOnly": "Solo non lette",
        "updated_at_asc": "Più vecchie prima",
        "updated_at_desc": "Più recenti prima"
      },
      "other_user": "e 1 altro",
      "other_users": "e 1 altro | e {count} altri",
      "partners": {
        "decision": {
          "message": {
            "create": "ha inviato un nuovo messaggio nella conversazione <i>'{group_name}'</i>. | ha inviato {group_notification_count} nuovi messaggi nella conversazione <i>'{group_name}'</i>. |_| hanno inviato {group_notification_count} nuovi messaggi nella conversazione <i>'{group_name}'</i>."
          },
          "not_interested": "non è interessato alla decisione <i>'{notifiable_name}'</i>.",
          "published": {
            "partners": "ha avviato la decisione <i>'{notifiable_name}'</i>. | ha avviato {group_notification_count} decisioni <i>'{group_name}'</i>. |_| hanno avviato {group_notification_count} decisioni <i>'{group_name}'</i>."
          }
        },
        "decision_document": {
          "create": "ha caricato il documento <i>'{notifiable_name}'</i> nella decisione <i>'{group_name}'</i>. | ha caricato {group_notification_count} documenti nella decisione <i>'{group_name}'</i>. |_| hanno caricato {group_notification_count} documenti nella decisione <i>'{group_name}'</i>."
        },
        "decision_proposal": {
          "approved": "ha approvato la proposta <i>'{notifiable_name}'</i> nella decisione <i>'{group_name}'</i>. | ha approvato la proposta <i>'{notifiable_name}'</i> nella decisione <i>'{group_name}'</i>. | ha approvato una proposta nella decisione <i>'{group_name}'</i>. | ha approvato delle proposte nella decisione <i>'{group_name}'</i>.",
          "create": "ha creato la proposta <i>'{notifiable_name}'</i> nella decisione <i>'{group_name}'</i>. | ha creato {group_notification_count} proposte nella decisione <i>'{group_name}'</i>. |_| hanno creato {group_notification_count} proposte nella decisione <i>'{group_name}'</i>.",
          "requested_changes": "chiede modifiche per la proposta <i>'{notifiable_name}'</i> nella decisione <i>'{group_name}'</i>. | chiede modifiche per {group_notification_count} proposte nella decisione <i>'{group_name}'</i>. |_| chiedono modifiche per {group_notification_count} proposte nella decisione <i>'{group_name}'</i>."
        },
        "document": {
          "create": "ha condiviso il documento <i>'{notifiable_name}'</i> con Lei. | ha condiviso {group_notification_count} documenti con Lei. |_| hanno condiviso {group_notification_count} documenti con Lei.",
          "proposal": {
            "create": "ha aggiunto il documento <i>'{notifiable_name}'</i> alla proposta <i>'{group_name}'</i>. | ha aggiunto {group_notification_count} documenti alla proposta <i>'{group_name}'</i>. |_| hanno aggiunto {group_notification_count} documenti alla proposta <i>'{group_name}'</i>."
          }
        },
        "export": {
          "create": "I Suoi dati esportati sono pronti per essere scaricati."
        },
        "issue": {
          "status": {
            "update": "ha aggiornato lo stato di una segnalazione in <i>'{group_name}'</i>. | ha aggiornato lo stato di {group_notification_count} segnalazioni in <i>'{group_name}'</i>. |_| hanno aggiornato lo stato di {group_notification_count} segnalazioni in <i>'{group_name}'</i>."
          }
        },
        "issue_list": {
          "published": "ha pubblicato l'elenco segnalazioni <i>'{notifiable_name}'</i> | ha pubblicato l'elenco segnalazioni <i>'{notifiable_name}'</i> per {group_notification_count} unità |_| hanno pubblicato l'elenco segnalazioni <i>'{notifiable_name}'</i> per {group_notification_count} unità"
        },
        "reminder": {
          "due": "<i>'{notifiable_name}'</i> non è stata ancora decisa per l'unità {level_name}."
        },
        "ticket_document": {
          "create": "ha caricato il documento <i>'{notifiable_name}'</i> nella conversazione <i>'{group_name}'</i>. | ha caricato {group_notification_count} documenti nella conversazione <i>'{group_name}'</i>. |_| hanno caricato {group_notification_count} documenti nella conversazione <i>'{group_name}'</i>."
        },
        "unit": {
          "visibled": "ha aggiunto il cliente <i>'{customer_group_name}'</i> a <i>'{group_name}'</i> per l'unità <i>'{notifiable_name}'</i>."
        }
      },
      "title": "Notifiche"
    }
  }
}
